import vars from '../../theme/vars';

const loginStyle = {
  leftSide: {
    display: 'flex',
    width: '35%',
    flexDirection: 'column',
    backgroundColor: '#010101',
    color: 'white',
    padding: '4% 6%',
    justifyContent: 'space-around',
  },

  loginBoxStyle: {
    flex: 1,
    overflow: 'hidden',
    borderColor: vars.colors.white,
  },

  loginText: {
    zIndex: 1,
    fontFamily: 'Montessart',
    color: '#0e0d25',
    fontWeight: 700,
    fontSize: 20,
    marginBottom: 0,
  },
  errorStyle: {
    ...vars.headings.h14,
    color: vars.colors.error,
    textAlign: 'center',
  },
};

export default loginStyle;
